<ion-header no-border mode="md">
    <ion-toolbar color="primary" mode="md">
        <ion-title>
        {{ 'Adicionar Usuário' }}
        </ion-title>
        <ion-buttons slot="end">
        <ion-button color="light" (click)="dismiss()" mode="ios">
            <ion-icon class="bp-close"></ion-icon>
        </ion-button>
        </ion-buttons>
    </ion-toolbar>
    <ion-toolbar color="primary" search mode="md">
        <ion-searchbar mode="ios"
        class="section-search-custom"
        [placeholder]="'generic.searchByName' | translate"
        (keyup)="onChangeSearch($event)"
        ></ion-searchbar>
    </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
    <ion-list class="users" >
        <ion-item *ngFor="let user of users; let i = index;" >
            <p class="user" (click)="selectUser(i)" >
                <b>{{ user.name }}</b> - {{ user.attribute1 }}, {{ user.attribute2 }}<br>
            </p>
        </ion-item>
    </ion-list>
</ion-content>